import React from 'react'
import Colors from "./../../Global/colors";
import notPermitted from '../../Assets/not_permitted.png'

function NotPermitted() {
    return (
        <div style={{backgroundColor:Colors.globalColor9, width:'100%', height:'100%', padding:'20px', display:'flex', textAlign:'center', justifyContent:'center', alignItems:'center'}}>
            <img src={notPermitted} alt="not Permitted" width="80%"/>
        </div>
    )
}

export default NotPermitted
 